const fatherStatus = [
  { label: "Government Service", value: "Government Service" },
  { label: "Private Service", value: "Private Service" },
  { label: "Businessman", value: "Businessman" },
  { label: "Not Employed", value: "Not Employed" },
  { label: "Retired", value: "Retired" },
  { label: "Passed Away", value: "Passed Away" },
];
export default fatherStatus;
